import React, { useState, Fragment } from 'react'
import { CardProduct } from '../../components/CardProduct'
import { Col, Row, Modal, Button } from 'antd';
import './modal.css'


export const Productos = ({ linea }) => {

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');

    const showModal = ( titleModal, messageModal ) => {
      setContent(messageModal);
      setTitle(titleModal);
      setIsModalVisible(true);
    };

    const handleOk = () => {
      setIsModalVisible(false);
    };

    const productos = [
      {
        id: 1,
        linea: 1,
        urlImage: require('../../../src/images/termoprotector.png'),
        title: 'Tratamiento Capilar',
        description: (<Fragment>
                        <b>Activos más importantes en nuestro producto: </b>
                        Aceites naturales tales como aceite de aguacate, aceite de argán, aceite de coco...
                        <br/>
                    </Fragment>
        ),
        messageModal: (<Fragment>
          <b>Activos más importantes: </b>
          Aceites naturales tales como aceite de aguacate, aceite de argán, aceite de coco; complejos de proteína, manteca de karité, extractos naturales y agentes acondicionadores.
          <br/>
          <br/>
          <b>Beneficios: </b>
          Formula Profesional. Tratamiento para reparar el cabello dañado causado 
          por el procesamiento químico y expuestos a procesos térmicos. Nuestro tratamiento 
          de brinda una Hidratación profunda con acción anti-frizz, también formulado para
          mitigar las agresiones térmicas, por lo que nuestro tratamiento funciona también 
          como protección al calor sometido mecánicamente. Nuestros activos funcionales 
          ayudan a la Formación del folículo del pelo, crecimiento capilar, dejando tu cabello 
          renovado con una apariencia y sensación más saludable.
      </Fragment>
),
      },
      {
        id:2,
        linea: 2,
        urlImage: require('../../../src/images/gel_facial.png'),
        title: 'Gel Facial',
        description: (<Fragment>
                  <b>Activos más importantes: </b>
                  Vitamina B3, Vitamina E, extractos de Aloe Vera, activo aclarante, ácido salicílico...
                  <br/>
              </Fragment>
        ),
        messageModal: (<Fragment>
          <b>Activos más importantes: </b>
          Vitamina B3, Vitamina E, extractos de Aloe Vera, activo aclarante, ácido salicílico 
          y extractos Hamamelis, caléndula, extracto vegetales y extractos de frutas
          <br/>
          <br/>
          <b>Beneficios: </b>
          Formula profesional, creado para ayudar a disolver los residuos de la piel 
          que obstruyen los poros y causan el acné. Promueve la actividad antibacteriana y 
          disuelve el exceso de sebo acumulado, esto gracias al ácido salicílico y extracto de 
          Hamamelis. Posee Vitamina B3 y un componente activo aclarante, que nos ayudara 
          a tonificar las manchas, reduce el tamaño de los poros dilatados y ayuda a reducir los 
          signos de envejecimiento; mezclado con componentes de Vitamina E como protector 
          de los radicales libres, siendo estos radicales los primeros causantes del 
          envejecimiento prematuro. Ricos en antioxidantes gracias a nuestros extractos 
          naturales.
      </Fragment>
),
      },
      {
        id:3,
        linea: 2,
        urlImage: require('../../../src/images/exfoliante.png'),
        title: 'Exfoliante Facial',
        description: (<Fragment>
          <b>Activos más importantes: </b>
          Kaolin, Manzanilla, extractos vegetales, extractos de frutas, dióxido de titanio...
          <br/>
      </Fragment>
),
        messageModal: (<Fragment>
          <b>Activos más importantes: </b>
          Kaolin, Manzanilla, extractos vegetales, extractos de frutas, dióxido de titanio y óxido de zinc, Vitamina E, extractos de Aloe Vera.
          <br/>
          <br/>
          <b>Beneficios: </b>
          Formula profesional creada con arcilla blanca, es un tratamiento 
          exfoliante suave adecuado para todo tipo de pieles. Deja la piel suave, lisa y libre de 
          impurezas. Enriquecido con aceite hidratante con propiedades refrescantes, 
          antisépticas y estimulantes, limpia, desintoxica y aclara la piel. El aloe vera, la 
          vitamina E y nuestros extractos purifican y calman la piel. Poseemos componentes 
          como el dióxido de titanio nos ayuda a protegernos de la radiación UV y óxido de 
          zinc como ayudante de frenar el crecimiento de microorganismo en la piel y la 
          radiación de UV.
      </Fragment>
),
      }
    ]

    return (
      
      <div className='divMarginContent'>
        <Modal title={title} 
          visible={isModalVisible} 
          onOk={handleOk} 
          onCancel={handleOk}
          className='modalStyle'
          width={600}
          closable={false}
          footer={[
            <Button key="back" onClick={handleOk} style={{ background: '#9A8313', color: '#fff' }}>
              Cerrar
            </Button>
          ]}>
          <p>{content}</p>
        </Modal>
        <Row gutter={[16, 34]}>
            {
              linea ? productos.filter(product => product.linea == linea).map(product => 
                <Col span={24} md={{ span: 8 }} key={product.id}>
                  <CardProduct onClick={() => showModal(product.title, product.messageModal)} {...product}  />
                </Col>
              ) :
              productos.map(product => 
                <Col span={24} md={{ span: 8 }} key={product.id}>
                  <CardProduct onClick={() => showModal(product.title, product.messageModal)} {...product} />
                </Col>
              )
            }
        </Row>
      </div>
    )
  }